// Swiper initialization for Product Range section
document.addEventListener('DOMContentLoaded', () => {
  // eslint-disable-next-line no-new, no-undef
  new Swiper('.product-range-swiper', {
    loop: true,
    spaceBetween: 20,
    slidesPerView: 'auto',
    slidesOffsetBefore: 20,
    breakpoints: {
      440: {
        slidesPerView: 1.5,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 3.2,
        spaceBetween: 6,
      },
      1024: {
        slidesPerView: 4.2,
        spaceBetween: 6,
        slidesOffsetBefore: 0,
      },
      1280: {
        slidesPerView: 4.2,
        spaceBetween: 6,
        slidesOffsetBefore: 0,
      },
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'progressbar',
    },
    grabCursor: true,
    keyboard: {
      enabled: true,
    },
    mousewheel: {
      invert: false,
      forceToAxis: true,
    },
  });
});
